import classNames from "classnames";
import { useState } from "react";
import styles from "./PlusMinusToggle.module.css";

export const PlusMinusToggle = ({
    key,
    handleExpand,
    children
}) => {
    const [expanded, setExpanded] = useState(false);

    const handleOptionExpand = (bool: boolean) => {
        setExpanded(bool);
        handleExpand();
    };

    return (
        <button
            key={key}
            onClick={() => handleOptionExpand(!expanded)}
            className={styles.wrapper}>
            <span
                className={classNames(styles.plusMinusToggle, { active: expanded })}
            >
                <hr /><hr />
            </span>

            <div>{children}</div>
        </button>


    )
};

